export default "__VITE_ASSET__8917cc42__"